<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="老人姓名" required prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入老人姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="紧急联系人" required prop="urgencyContact">
                  <el-input v-model="addForm.urgencyContact" placeholder="请输入紧急联系人"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="紧急联系人手机" required prop="urgencyPhone">
                  <el-input v-model="addForm.urgencyPhone" placeholder="请输入紧急联系人手机"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="老人手机号">
                  <el-input v-model="addForm.phone" minlength="11" placeholder="请输入老人手机号"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="老人身份证号">
                  <el-input v-model="addForm.idCard" placeholder="请输入老人身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="老人家庭地址">
                  <el-input v-model="addForm.homeAddress" placeholder="请输入老人家庭地址"></el-input>
                </el-form-item>
              </el-col>


            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name: '',
        urgencyContact:'',
        urgencyPhone:'',

        phone:'',
        idCard: '',
        homeAddress: '',

      },

      rules:{

        name:[
          { required: true, message: '请输入老人姓名', trigger: 'blur' },
        ],
        urgencyContact:[
          { required: true, message: '请输入紧急联系人', trigger: 'blur' },
        ],
        urgencyPhone:[
          { required: true, message: '请输入紧急联系人手机号', trigger: 'blur' },
        ],

      },

    }
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

      this.addForm.name = '';
      this.addForm.phone = '';
      this.addForm.urgencyPhone = '';
      this.addForm.urgencyContact = '';
      this.addForm.idCard = '';
      this.addForm.homeAddress = '';

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyAdm/InsAdd",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    }


  }
}


</script>

